!function (n, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Kapsule = t() : n.Kapsule = t();
}("undefined" != typeof self ? self : this, function () {
  return function (n) {
    var t = {};

    function e(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return n[r].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }

    return e.m = n, e.c = t, e.d = function (n, t, r) {
      e.o(n, t) || Object.defineProperty(n, t, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, e.n = function (n) {
      var t = n && n.__esModule ? function () {
        return n.default;
      } : function () {
        return n;
      };
      return e.d(t, "a", t), t;
    }, e.o = function (n, t) {
      return Object.prototype.hasOwnProperty.call(n, t);
    }, e.p = "", e(e.s = 0);
  }([function (n, t, e) {
    var r, o, i;
    u = function u(n, t, e) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function (n) {
        var t = n.stateInit,
            e = void 0 === t ? function () {
          return {};
        } : t,
            r = n.props,
            a = void 0 === r ? {} : r,
            f = n.methods,
            l = void 0 === f ? {} : f,
            c = n.aliases,
            s = void 0 === c ? {} : c,
            d = n.init,
            p = void 0 === d ? function () {} : d,
            v = n.update,
            h = void 0 === v ? function () {} : v,
            y = Object.keys(a).map(function (n) {
          return new u(n, a[n]);
        });
        return function () {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = Object.assign({}, e instanceof Function ? e(n) : e, {
            initialised: !1
          });

          function r(t) {
            return u(t, n), a(), r;
          }

          var u = function u(n, e) {
            p.call(r, n, t, e), t.initialised = !0;
          },
              a = (0, o.default)(function () {
            t.initialised && h.call(r, t);
          }, 1);

          return y.forEach(function (n) {
            r[n.name] = function (n) {
              var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                  o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function (n, t) {};
              return function (i) {
                var u = t[n];
                return arguments.length ? (t[n] = i, o.call(r, i, t, u), e && a(), r) : u;
              };
            }(n.name, n.triggerUpdate, n.onChange);
          }), Object.keys(l).forEach(function (n) {
            r[n] = function () {
              for (var e, o = arguments.length, i = Array(o), u = 0; u < o; u++) {
                i[u] = arguments[u];
              }

              return (e = l[n]).call.apply(e, [r, t].concat(i));
            };
          }), Object.entries(s).forEach(function (n) {
            var t = i(n, 2),
                e = t[0],
                o = t[1];
            return r[e] = r[o];
          }), r.resetProps = function () {
            return y.forEach(function (n) {
              r[n.name](n.defaultVal);
            }), r;
          }, r.resetProps(), t._rerender = a, r;
        };
      };
      var r,
          o = (r = e, r && r.__esModule ? r : {
        default: r
      });

      var i = function () {
        return function (n, t) {
          if (Array.isArray(n)) return n;
          if (Symbol.iterator in Object(n)) return function (n, t) {
            var e = [],
                r = !0,
                o = !1,
                i = void 0;

            try {
              for (var u, a = n[Symbol.iterator](); !(r = (u = a.next()).done) && (e.push(u.value), !t || e.length !== t); r = !0) {
                ;
              }
            } catch (n) {
              o = !0, i = n;
            } finally {
              try {
                !r && a.return && a.return();
              } finally {
                if (o) throw i;
              }
            }

            return e;
          }(n, t);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }();

      var u = function n(t, e) {
        var r = e.default,
            o = void 0 === r ? null : r,
            i = e.triggerUpdate,
            u = void 0 === i || i,
            a = e.onChange,
            f = void 0 === a ? function (n, t) {} : a;
        !function (n, t) {
          if (!(n instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, n), this.name = t, this.defaultVal = o, this.triggerUpdate = u, this.onChange = f;
      };

      n.exports = t.default;
    }, o = [n, t, e(1)], void 0 === (i = "function" == typeof (r = u) ? r.apply(t, o) : r) || (n.exports = i);
    var u;
  }, function (n, t) {
    n.exports = function (n, t, e) {
      var r, o, i, u, a;
      null == t && (t = 100);

      function f() {
        var l = Date.now() - u;
        l < t && l >= 0 ? r = setTimeout(f, t - l) : (r = null, e || (a = n.apply(i, o), i = o = null));
      }

      var l = function l() {
        i = this, o = arguments, u = Date.now();
        var l = e && !r;
        return r || (r = setTimeout(f, t)), l && (a = n.apply(i, o), i = o = null), a;
      };

      return l.clear = function () {
        r && (clearTimeout(r), r = null);
      }, l.flush = function () {
        r && (a = n.apply(i, o), i = o = null, clearTimeout(r), r = null);
      }, l;
    };
  }]);
});